import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn'; // We'll create this utility or just use inline classes if preferred, but let's stick to standard prop passing for now.
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  fullWidth = false,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-bold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-gold-500 focus:ring-offset-2 focus:ring-offset-dark-900';
  const variants = {
    primary: 'bg-gold-500 text-dark-900 hover:bg-gold-400 shadow-gold-glow',
    secondary: 'bg-dark-700 text-white hover:bg-dark-600 border border-white/10',
    outline: 'bg-transparent border-2 border-gold-500 text-gold-500 hover:bg-gold-500/10'
  };
  const sizes = 'px-8 py-4 text-lg';
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-161">
      {children}
    </motion.button>;
}